export default __webpack_public_path__ + "static/media/fb-icon.07d53184.svg";